var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('document', 'documentElement');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/html.js
// module id = 688
// module chunks = 49